export const colors = {
  ground: "var(--background)",
  rail: "var(--rail)",
  surface: "var(--surface)",
  surfaceHover: "var(--surface-hover)",
  inspector: "var(--surface-inspector)",
  well: "var(--surface-well)",
  depth: "var(--surface-depth)",
  hairline: "var(--line)",
  hairlineStrong: "var(--line-strong)",
  hairlineLight: "var(--line-light)",
  text: "var(--text)",
  text2: "var(--text-2)",
  text3: "var(--text-3)",
  text4: "var(--text-4)",
  brand: "var(--brand)",
  brandHover: "var(--brand-hover)",
  brandPress: "var(--brand-press)",
  brandText: "var(--brand-text)",
  brandHairline: "var(--brand-line)",
  onBrand: "var(--on-brand)",
  tint1: "var(--tint-1)",
  tint2: "var(--tint-2)",
  green: "var(--green)",
  greenFill: "var(--green-surface)",
  amber: "var(--warn)",
  amberFill: "var(--warning-surface)",
  error: "var(--error)",
  errorText: "var(--error-text)",
  errorFill: "var(--error-surface)",
  community: "var(--community)",
  communityFill: "var(--community-surface)",
  raid: "var(--raid)",
  raidFill: "var(--raid-surface)",
  moderation: "var(--moderation)",
  moderationFill: "var(--moderation-surface)",
} as const;
